module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/pr-allotment/pr-allotment-notsent/pr-allotment-notsent.component.css
// module id = ./src/app/allocation/pr-allotment/pr-allotment-notsent/pr-allotment-notsent.component.css
// module chunks = main